import { render, staticRenderFns } from "./WorkgroupsDropdown.vue?vue&type=template&id=54263e27&scoped=true&"
import script from "./WorkgroupsDropdown.vue?vue&type=script&lang=js&"
export * from "./WorkgroupsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./WorkgroupsDropdown.vue?vue&type=style&index=0&id=54263e27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54263e27",
  null
  
)

export default component.exports